export default "__VITE_ASSET__b5b600ec__"